import React, { useContext } from "react";
import MainStateContext from "../../../state/mainStateContext";
import { StateContextType } from "../../../types/state.types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import SimpleFileInput from "./SimpleFileInput";
import { Say } from "../../../languages";

type Props = {
  visible: boolean;
  photoType: string;
  isServiceError: boolean;
  children: React.ReactNode;
  handlePhotoBoothClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const PhotoReject = ({
  visible,
  photoType,
  isServiceError,
  children,
  handlePhotoBoothClick,
  handleFileChange
}: Props) => {
  const { state } = useContext(MainStateContext) as StateContextType;
  const { currentOrder } = state;

  if (!visible) {
    return null;
  }

  return (
    <div>
      {children}

      <span className="photo-reject__icon">
        <FontAwesomeIcon icon={faExclamationCircle} />
      </span>
      <p className="photo-reject__text">
        {isServiceError ? (
          <Say phrase="errors.service_error" />
        ) : (
          <Say phrase="photo_step.photo_reject_message" />
        )}
      </p>

      <div className="photo-reject__button-wrapper">
        {["booth", "all"].includes(photoType) && !currentOrder?.orderId ? (
          <button className="btn btn-primary" onClick={handlePhotoBoothClick}>
            <Say phrase="photo_step.booth_cta" />
          </button>
        ) : null}
        <SimpleFileInput
          labelPhraseKey={
            isServiceError
              ? "photo_step.photo_retake_service_error_cta"
              : "photo_step.photo_retake_cta"
          }
          handleFileChange={handleFileChange}
          visible={photoType !== "booth"}
        />
      </div>
    </div>
  );
};

export default PhotoReject;
